export default "__VITE_PUBLIC_ASSET__288bca0d__"